module.exports = __webpack_public_path__ + "static/media/ico_sort_up.108fa9a1.svg";